module.exports = __webpack_public_path__ + "static/media/Ferual-text.079e456a.svg";